import { User } from 'lucide-react';
import { clsx } from 'clsx';

export interface StaffOption {
  id: string;
  name: string;
  count?: number;
}

export interface StaffFilterProps {
  options: StaffOption[];
  selected: string;
  onChange: (id: string) => void;
  className?: string;
}

export function StaffFilter({ options, selected, onChange, className }: StaffFilterProps) {
  return (
    <div className={clsx('flex items-center gap-1.5 text-xs text-text-secondary', className)}>
      <User size={13} className="text-text-muted flex-shrink-0" />
      <span className="hidden sm:inline text-[11px] text-text-muted font-medium">Profesional:</span>
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Filtrar por profesional"
        className="bg-surface-secondary border border-border text-text-primary rounded-lg px-2.5 py-1.5 text-xs font-medium focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer max-w-[170px] truncate transition-colors"
      >
        <option value="all" className="bg-surface text-text-primary font-semibold">
          Todos los profesionales
        </option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id} className="bg-surface text-text-primary font-medium">
            {opt.name} {opt.count !== undefined ? `(${opt.count})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
